require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-kiko-chippo-hotel.json") })
        }
      }, "path---interview-kiko-chippo-hotel");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-kiko-chippo-hotel!./.cache/json/interview-kiko-chippo-hotel.json
// module id = 686
// module chunks = 231608221292675